import React, { useCallback } from 'react';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { useStore } from "../../redux/Store";
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import TextField from "@material-ui/core/TextField";
import MenuItem from '@mui/material/MenuItem';
import { MonthsEnum, MonthsTransformer } from '../../types/MonthsEnum';
import '../../types/variables.css';
import Box from '@mui/material/Box';
import { IftUser } from "../../auth/user";
import {useSessionStorage} from "usehooks-ts";
import { toast } from 'react-hot-toast';
import action from '../Action';
import { postRTUpdates } from '../../apis/configs/axiosUtils';
import moment from 'moment';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles(theme => ({
 
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow:'scroll',
    height:'auto',
    backgroundColor: '#1A2C80',
    background: '#1A2C80'
    }, 
  paper: {
    backgroundColor: 'white',
    background: 'white',
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    },
  elementContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    }, 
  innerContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    },
  label: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    overflow: 'none',
    width: '125px',
    paddingTop: '10px',
    fontSize: '12pt',
    marginRight: '10px'
    },
  labelRight: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    overflow: 'none',
    width: '125px',
    paddingTop: '10px',
    paddingRight: '10px',
    fontSize: '12pt'
    },
  Headers: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    overflow: 'none',
    fontSize: '11pt',
    fontStyle: 'italic'
    },
  field: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    overflow: 'none',
    paddingRight: '20px'
    },
  buttonRight: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    overflow: 'none',
    margin: '5px',
    width: '80px'
    },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    overflow: 'none',
    },
  })
);

const confirmModal = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '400',
  bgcolor: 'background.paper',
  border: '2px solid #304CB2',
  boxShadow: '24',
  padding: '10px',
  pt: '2',
  px: '4',
  pb: '3',
  };

function ConfirmModal() {
  const classes = useStyles();
  const store = useStore();
  const [user] = useSessionStorage<null | IftUser>('ift.user', null);
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const updatedUserDetails = {...store.state.selectedUserDetails}

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleLoading = () => {
    setLoading((prevLoading) => !prevLoading);
  };
  const handleSubmit = useCallback(async () => {
    const { dispatch } = store;
    handleLoading();
    const updatedUserDetails = {...store.state.selectedUserDetails}
    const modifiedBy = user.userName
    let updatedUserDetailsPayload = {
      "EMP_NUM": updatedUserDetails.emp_no,
      "RT_BASE_MONTH": updatedUserDetails.rt_month,
      "RT_QUAL_EXP_DT": updatedUserDetails.exp_date,
      "MODIFIED_BY": modifiedBy
    }

    try {
      await postRTUpdates(updatedUserDetailsPayload)
      handleLoading();
      toast.success('User Details saved!', {
        style: {
          border: '1px solid #e5e3e3',
          padding: '16px',
          color: '#1A2C80'
          }
        });
      setOpen(false);
      updatedUserDetails.show_details = false;
      dispatch(action("SELECTED_USER_DETAILS", updatedUserDetails));
    } catch (error) {
      handleLoading();
      toast.error('Save User Details failed: \n' + error, {
        style: {
          border: '1px solid #D5152E',
          padding: '16px',
          color: '#1A2C80'
          }
        });
    }
  }, [store, user]);

  return (
    <React.Fragment>
      <Button variant="contained" onClick={handleOpen} className={classes.buttonRight} style={{ color: '#fff', backgroundColor: '#304CB2'}}>Save</Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box sx={{ ...confirmModal, width: 250 }}>
          <h2 id="child-modal-title">Confirm</h2>
          <p id="child-modal-description">
          Save changes to user, {updatedUserDetails.emp_no}'s RT Expiration Date: {updatedUserDetails.exp_date}?  
          </p>
          {
          loading ?
          <div className={classes.buttonContainer}><CircularProgress /><br /> <br />Saving changes...</div>: 
          <div className={classes.buttonContainer}>
            <Button variant="contained" style={{ color: '#fff', backgroundColor: '#304CB2'}} type='submit' onClick={handleSubmit} className={classes.buttonRight} title='Save current RT changes and close the User Details dialog'>Save</Button>
            <Button variant="contained" style={{ color: '#fff', backgroundColor: '#D5152E'}} onClick={handleClose} className={classes.buttonRight} title='Discard the current RT changes and return to the User Details dialog'>Cancel</Button>
          </div>
          }
        </Box>
      </Modal>
    </React.Fragment>
  );
}

export default function UserDetails() {
  const classes = useStyles();
  const store = useStore();

  const handleInputChange = useCallback((e: { target: { name: any; value: any; }; }) => {
    const { value } = e.target;
    const { dispatch } = store;
    const selectedDate = moment(value);
    if (selectedDate.get('month') === 11) {
      selectedDate.set('month', 10);
      toast.error('Invalid RT Expiration month, selection will change to closest valid date.', {
        id: 'errorT',
        style: {
          border: '1px solid #D5152E',
          padding: '16px',
          color: '#1A2C80'
          }
        });
    }
    const dateWithLastDay = selectedDate.endOf('month');
    const dateStrWithLastDay = dateWithLastDay.format("yyyy-MM-DD");
    const monthStr = MonthsTransformer[selectedDate.month()];
    const resultsInput = {...store.state.selectedUserDetails, exp_date: dateStrWithLastDay, rt_month: monthStr};
    dispatch(action("SELECTED_USER_DETAILS", resultsInput));
  }, [store]);

  const handleClose = useCallback(() => {
    const { dispatch } = store;
    const resultsClose = {...store.state.selectedUserDetails}
    resultsClose.show_details = false;
    dispatch(action("SELECTED_USER_DETAILS", resultsClose));
  }, [store]);

  return (
    <div>
      {/* <Button variant="contained" style={{ color: '#fff', backgroundColor: '#304CB2'}} onClick={handleOpen}>
        Open User Details 
      </Button> */}

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        style={{overflow: 'auto'}}
        className={classes.modal} 
        open={store.state.selectedUserDetails.show_details}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
            timeout: 500,
        }}
      >
        <Fade in={store.state.selectedUserDetails.show_details}>
        <div className={classes.paper}>
        <div className={classes.elementContainer}>
          <div className={classes.Headers}>
          <h2>Employee Details</h2>
          </div>
          <div className={classes.innerContainer}>
            <div className={classes.innerContainer}>
              <div className={classes.label}>
              Employee No
              </div>
              <div className={classes.field}>
              <TextField 
                disabled
                type='text' 
                defaultValue={store.state.selectedUserDetails.emp_no}
                variant='outlined'
                name='emp_no'
                inputProps={{ readOnly: true, }} 
              />
              </div>
            </div>
            <div className={classes.innerContainer}>
              <div className={classes.labelRight}>
              Location
              </div>
              <div className={classes.field}>
              <TextField 
                disabled
                type='text' 
                defaultValue={store.state.selectedUserDetails.location}
                variant='outlined'
                name='location'
                /*label='Location'*/
                inputProps={{ readOnly: true, }} 
                style={{width: 70}}
              />
              </div>
            </div>
            <div className={classes.innerContainer}>
              <div className={classes.labelRight}>
              Status
              </div>
              <div className={classes.field}>
              <TextField 
                disabled
                type='text' 
                defaultValue={store.state.selectedUserDetails.status}
                variant='outlined'
                name='status'
                /*label='Status'*/
                inputProps={{ readOnly: true, }} 
              />
              </div>
            </div>
            </div> 
            <br />
            < div className={classes.innerContainer}>
              <div className={classes.innerContainer}>
                <div className={classes.label}>
                First Name
                </div>
                <div className={classes.field}>
                <TextField 
                  disabled
                  type='text' 
                  defaultValue={store.state.selectedUserDetails.first_name}
                  variant='outlined'
                  name='first_name'
                  /*label='Name'*/
                  inputProps={{ readOnly: true, }}
                  style = {{width: 400}}
                />
                </div>
              </div>
              <div className={classes.innerContainer}>
                <div className={classes.labelRight}>
                Seniority No
                </div>
                <div className={classes.field}>
                <TextField 
                  disabled
                  type='text' 
                  defaultValue={store.state.selectedUserDetails.seniority_no}
                  variant='outlined'
                  name='seniority_no'
                  /*label='Seniority'*/
                  inputProps={{ readOnly: true, }} 
                />
                </div>
              </div>
            </div>
            <br />
            <div className={classes.innerContainer}>
              <div className={classes.innerContainer}> 
                <div className={classes.label}>
                Last Name
                </div>
                <div className={classes.field}>
                <TextField
                  disabled 
                  type='text' 
                  defaultValue={store.state.selectedUserDetails.last_name}
                  variant='outlined'
                  name='last_name'
                  /*label='Last Name'*/
                  inputProps={{ readOnly: true, }} 
                  style = {{width: 400}}
                />
                </div>
              </div>
            </div>
            <br />
            <div className={classes.innerContainer}>
              <div className={classes.innerContainer}>
                <div className={classes.label}>
                Job Title
                </div>
                < div className={classes.field}>
                <TextField 
                  disabled
                  type='text' 
                  defaultValue={store.state.selectedUserDetails.job_title}
                  variant='outlined'
                  name='job_title'
                  /*label='Job Title'*/
                  inputProps={{ readOnly: true, }} 
                  style = {{width: 325}}
                />
                </div>
              </div> 
            </div>
            <div className={classes.Headers}>
            <h2>Recurrent Training Data</h2>
            </div>
            <div className={classes.innerContainer}>
              <div className={classes.innerContainer}>
                <div className={classes.label}>
                RT Month
                </div>
                <div className={classes.field}>
                <TextField 
                  id="RT-month-input"
                  variant="outlined"
                  name="rt_month"
                  type="text"
                  select
                  value={store.state.selectedUserDetails.rt_month}
                  disabled
                  inputProps={{ readOnly: true, }} 
                  style={{width: 100}}
                >
                  {MonthsEnum.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                  
                </TextField>

                </div>
              </div>
            </div>
            <br />
            <div className={classes.innerContainer}>
              <div className={classes.innerContainer}>
                <div className={classes.label}>
                RT Qual Exp Date
                </div>
                <div className={classes.field}>
                  <TextField 
                  id="rt-qual-exp-input"
                  variant="outlined"
                  name="exp_date"
                  type="date"
                  onChange={handleInputChange}
                  value={store.state.selectedUserDetails.exp_date}
                  />
                </div>
              </div>
            </div>
        </div>
        <br />
        <div className={classes.buttonContainer}>
            <ConfirmModal /> 
            <Button variant="contained" style={{ color: '#fff', backgroundColor: '#D5152E'}} onClick={handleClose} className={classes.buttonRight} title= 'Discard User Details changes and return to User Search Results dialog'>
              Cancel
            </Button>
          </div>
        </div>
      </Fade>
      </Modal>
    </div>
  );
}
